import ApiClient from "../utils/ApiClient";

class ListingService {
  // Hardcoded fallback data matching reference design
  fallbackData = {
    agent: {
      name: "Nicole Pua",
      title: "Registered Real Estate Negotiator",
      subtitle: "JB PROPERTY AGENT",
      bio: "Ex-Finance Specialist in SG with expertise in finance, audit and business analysis.\nHonest advice, clear guidance, and genuine care — because every property decision shapes your future.",
      photoUrl: "/api/app-images/profile.jpg",
      whatsappNumber: "60163288120"
    },
    areas: [
      {
        id: "1",
        title: "BUKIT INDAH",
        imageUrl: "/api/app-images/popular-areas/bukit-indah.jpg",
        highlights: [
          "Near AEON & Lotus's",
          "Top Schools",
          "5 mins to Tuas Second Link Highway",
          "Established Township"
        ]
      },
      {
        id: "2",
        title: "HORIZON HILLS",
        imageUrl: "/api/app-images/popular-areas/horizon-hills.jpg",
        highlights: [
          "Golf Community",
          "Gated & Guarded",
          "Luxury Living",
          "Low Density"
        ]
      },
      {
        id: "24",
        title: "DANGA BAY",
        imageUrl: "/api/app-images/popular-areas/danga-bay.jpg",
        highlights: [
          "Waterfront Marina",
          "Stunning Sea Views",
          "10 Mins to CIQ",
          "Premium High-Rise Living"
        ]
      },
      {
        id: "25",
        title: "R&F",
        imageUrl: "/api/app-images/popular-areas/rf.jpg",
        highlights: [
          "Covered Walkway to CIQ",
          "Straits Sea Views",
          "Onsite Mall & Cinema",
          "Premium High-Rise Living"
        ]
      },
      {
        id: "4",
        title: "ECO BOTANIC",
        imageUrl: "/api/app-images/popular-areas/eco-botanic.jpg",
        highlights: [
          "Green Environment",
          "International Schools",
          "Family Oriented",
          "Modern Township"
        ]
      },
      {
        id: "3",
        title: "NUSA SENTRAL",
        imageUrl: "/api/app-images/popular-areas/nusa-sentral.jpg",
        highlights: [
          "Affordable Homes",
          "New Development",
          "Good Investment",
          "Easy Access"
        ]
      },
      {
        id: "5",
        title: "NUSA IDAMAN",
        imageUrl: "/api/app-images/popular-areas/nusa-idaman.jpg",
        highlights: [
          "Award Winning Precinct",
          "Near Sireh Park",
          "Gated & Guarded",
          "Serene Green Living"
        ]
      },
      {
        id: "7",
        title: "AURORA SENTRAL",
        imageUrl: "/api/app-images/popular-areas/aurora-sentral.jpg",
        highlights: [
          "Modern Architecture",
          "Gated & Guarded",
          "Near EduCity",
          "Easy 2nd Link Access"
        ]
      },
      {
        id: "17",
        title: "ASPIRA",
        imageUrl: "/api/app-images/popular-areas/aspira.jpg",
        highlights: [
          "Freehold Estate",
          "Near 2nd Link",
          "Eco-Friendly",
          "Gated Community"
        ]
      },
      {
        id: "11",
        title: "MEDINI",
        imageUrl: "/api/app-images/popular-areas/medini.jpg",
        highlights: [
          "Business Hub",
          "Gleneagles Hospital",
          "Legoland Proximity",
          "High-Rise Living"
        ]
      },
      {
        id: "13",
        title: "SUNWAY",
        imageUrl: "/api/app-images/popular-areas/sunway.jpg",
        highlights: [
          "Integrated Township",
          "Emerald Lake",
          "Sunway International School",
          "Lakefront Living",
          "Modern Lifestyle"
        ]
      },
      {
        id: "20",
        title: "SETIA ECO VILLAGE",
        imageUrl: "/api/app-images/popular-areas/setia-eco-village.jpg",
        highlights: [
          "Eco-Conscious Design",
          "Solar Energy Built",
          "Gated Community",
          "Park Trails"
        ]
      },
      {
        id: "21",
        title: "SILC",
        imageUrl: "/api/app-images/popular-areas/silc.jpg",
        highlights: [
          "Industrial Park",
          "Logistics Hub",
          "Strategic Location",
          "Commercial Lots"
        ]
      },
      {
        id: "12",
        title: "SENADI HILLS",
        imageUrl: "/api/app-images/popular-areas/senadi-hills.jpg",
        highlights: [
          "Freehold Township",
          "Elevated Living",
          "Family Friendly",
          "Modern Design"
        ]
      },
      {
        id: "6",
        title: "PUTERI HARBOUR",
        imageUrl: "/api/app-images/popular-areas/puteri-harbour.jpg",
        highlights: [
          "Waterfront Marina",
          "Luxury Serviced Suites",
          "Fine Dining Promenade",
          "Ferry Terminal Access"
        ]
      },
      {
        id: "8",
        title: "EAST LEDANG",
        imageUrl: "/api/app-images/popular-areas/east-ledang.jpg",
        highlights: [
          "Resort Living",
          "Low Density",
          "Gated Security",
          "Near Tuas 2nd Link"
        ]
      },
      {
        id: "10",
        title: "LEDANG HEIGHTS",
        imageUrl: "/api/app-images/popular-areas/ledang-heights.jpg",
        highlights: [
          "Luxury Bungalows",
          "Expansive Land Sizes",
          "Gated Precinct",
          "High Privacy"
        ]
      },
      {
        id: "9",
        title: "ESTUARI GARDEN",
        imageUrl: "/api/app-images/popular-areas/estuari-garden.jpg",
        highlights: [
          "Coastal Living",
          "Gated Security",
          "Lush Parks",
          "Luxury Finishes"
        ]
      },
      {
        id: "22",
        title: "RINI HOMES 2",
        imageUrl: "/api/app-images/popular-areas/rini-homes-2.jpg",
        highlights: [
          "Mutiara Rini Township",
          "Near Hutan Bandar Park",
          "Mature Amenities",
          "Convenient Access"
        ]
      },
      {
        id: "23",
        title: "RINI HOMES 8",
        imageUrl: "/api/app-images/popular-areas/rini-homes-8.jpg",
        highlights: [
          "Guarded Precinct",
          "Modern Facade",
          "Close to Schools & Shops",
          "Easy Highway Access"
        ]
      }
    ],
    listings: [
      {
        id: "l1",
        title: "Double Storey Terrace",
        listingType: "FOR SALE",
        price: "RM 880,000",
        propertyType: "Double Storey Terrace",
        area: "Bukit Indah",
        bedrooms: "4",
        bathrooms: "3",
        size: "22 x 70",
        imageUrl: "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=600&q=80",
        tenure: "Freehold",
        lotType: "Non-Bumi Lot",
        tags: ["Freehold", "Non-Bumi Lot"],
        galleryImages: [
          "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1600573472550-8090b5e0745e?auto=format&fit=crop&w=1200&q=80"
        ]
      },
      {
        id: "l2",
        title: "2.5 Storey Semi-D",
        listingType: "FOR SALE",
        price: "RM 1,380,000",
        propertyType: "2.5 Storey Semi-D",
        area: "Horizon Hills",
        bedrooms: "4+1",
        bathrooms: "4",
        size: "40 x 80",
        imageUrl: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=600&q=80",
        tenure: "Freehold",
        lotType: "International Lot",
        tags: ["Freehold", "International Lot", "Golf View"],
        galleryImages: [
          "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80"
        ]
      },
      {
        id: "l3",
        title: "Cluster House",
        listingType: "FOR SALE",
        price: "RM 620,000",
        propertyType: "Cluster House",
        area: "Nusa Sentral",
        bedrooms: "4",
        bathrooms: "3",
        size: "20 x 65",
        imageUrl: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=600&q=80",
        tenure: "Freehold",
        lotType: "Bumi Lot",
        tags: ["Freehold", "Bumi Lot"],
        galleryImages: [
          "https://images.unsplash.com/photo-1600585154526-990dced4db0d?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1200&q=80"
        ]
      },
      {
        id: "l4",
        title: "Condo (The Peak)",
        listingType: "FOR SALE",
        price: "RM 1,150,000",
        propertyType: "Condo",
        area: "Bukit Indah",
        bedrooms: "3",
        bathrooms: "2",
        size: "1,200 sqft",
        imageUrl: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=600&q=80",
        tenure: "Freehold",
        lotType: "Non-Bumi Lot",
        tags: ["Freehold", "Non-Bumi Lot", "Fully Furnished"],
        galleryImages: [
          "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1567496898669-ee935f5f647a?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?auto=format&fit=crop&w=1200&q=80"
        ]
      },
      {
        id: "l5",
        title: "Luxury Condo",
        listingType: "FOR RENT",
        price: "RM 2,200 / mth",
        propertyType: "Condo",
        area: "Eco Botanic",
        bedrooms: "3",
        bathrooms: "2",
        size: "1,100 sqft",
        imageUrl: "https://images.unsplash.com/photo-1567496898669-ee935f5f647a?auto=format&fit=crop&w=600&q=80",
        tenure: "Freehold",
        lotType: "Non-Bumi Lot",
        tags: ["Freehold", "Non-Bumi Lot", "High Floor"],
        galleryImages: [
          "https://images.unsplash.com/photo-1567496898669-ee935f5f647a?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=1200&q=80",
          "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80"
        ]
      }
    ],
    newLaunch: {
      id: "p1",
      tag: "NEW LAUNCH",
      title: "The Peak @ Horizon Hills",
      priceRange: "Starting From RM 1.4 Million",
      features: ["Freehold", "Gated & Guarded", "Luxury Facilities"],
      imageUrl: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?auto=format&fit=crop&w=800&q=80"
    },
    testimonials: [
      {
        id: "t1",
        clientName: "Mr. Lim",
        clientLocation: "Singapore",
        comment: "Nicole was very professional and helpful throughout the entire process. Highly recommended!",
        rating: 5,
        avatarUrl: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150&q=80"
      },
      {
        id: "t2",
        clientName: "Jason Tan",
        clientLocation: "Bukit Indah",
        comment: "Found our dream home in Bukit Indah within 2 weeks. Great service!",
        rating: 5,
        avatarUrl: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=150&q=80"
      },
      {
        id: "t3",
        clientName: "Ms. Kelly",
        clientLocation: "Johor Bahru",
        comment: "Honest advice and very responsive. Will definitely recommend to friends.",
        rating: 5,
        avatarUrl: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150&q=80"
      }
    ]
  };

  formatImageUrl(url) {
    if (!url) return 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=600&q=80';

    // If external third-party URL (Unsplash, CDN, Cloudinary), return as-is
    if (url.startsWith('http://') || url.startsWith('https://')) {
      if (url.includes('images.unsplash.com') || url.includes('cdn.') || url.includes('cloudinary.')) {
        return url;
      }
      // If full internal URL (e.g. http://.../api/...), extract clean relative path
      try {
        const parsedUrl = new URL(url);
        return `${parsedUrl.pathname}${parsedUrl.search}`;
      } catch (e) {
        return url;
      }
    }

    const path = url.startsWith('/') ? url : `/${url}`;

    // If running in browser on a production/domain host (not localhost or 127.0.0.1), always return relative path directly
    if (typeof window !== 'undefined' && window.location) {
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      if (!isLocalhost) {
        return path;
      }
    }

    const envUrl = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_BASE_URL)
      ? process.env.REACT_APP_API_BASE_URL
      : 'http://localhost:8080/api';

    if (envUrl.startsWith('/')) {
      return path;
    }

    let host = 'http://localhost:8080';
    if (typeof window !== 'undefined' && window.location) {
      if (envUrl.startsWith('http://') || envUrl.startsWith('https://')) {
        try {
          const parsed = new URL(envUrl);
          host = `${window.location.protocol}//${window.location.hostname}:${parsed.port || '8080'}`;
        } catch (e) {
          host = `${window.location.protocol}//${window.location.hostname}:8080`;
        }
      }
    }

    return `${host}${path}`;
  }

  formatListing(item) {
    if (!item) return item;
    const formattedMain = this.formatImageUrl(item.imageUrl);
    const gallery = Array.isArray(item.galleryImages) && item.galleryImages.length > 0
      ? item.galleryImages.map(img => this.formatImageUrl(img))
      : [formattedMain];

    return {
      ...item,
      imageUrl: formattedMain,
      galleryImages: gallery
    };
  }

  formatArea(area) {
    if (!area) return area;
    return {
      ...area,
      imageUrl: this.formatImageUrl(area.imageUrl),
      bannerUrl: this.formatImageUrl(area.bannerUrl)
    };
  }

  async getAllData() {
    try {
      const data = await ApiClient.get("/listings/all-data");
      if (data) {
        if (data.listings) {
          data.listings = data.listings.map(item => this.formatListing(item));
        }
        if (data.areas) {
          data.areas = data.areas.map(area => this.formatArea(area));
        }
        if (data.popularAreas) {
          data.popularAreas = data.popularAreas.map(area => this.formatArea(area));
        }
      }
      return data || {
        ...this.fallbackData,
        areas: (this.fallbackData.areas || []).map(area => this.formatArea(area))
      };
    } catch (e) {
      console.warn("Backend server not reachable, using hardcoded listing data:", e);
      return {
        ...this.fallbackData,
        areas: (this.fallbackData.areas || []).map(area => this.formatArea(area))
      };
    }
  }

  async getPopularAreas() {
    try {
      const res = await ApiClient.get("/listings/areas");
      return (res || []).map(area => this.formatArea(area));
    } catch (e) {
      return (this.fallbackData.areas || []).map(area => this.formatArea(area));
    }
  }

  async getLatestListings() {
    try {
      const res = await ApiClient.get("/listings/latest");
      return (res || []).map(item => this.formatListing(item));
    } catch (e) {
      return this.fallbackData.listings;
    }
  }

  async getNewLaunch() {
    try {
      return await ApiClient.get("/listings/new-launch");
    } catch (e) {
      return this.fallbackData.newLaunch;
    }
  }

  async searchProperties(params) {
    try {
      const res = await ApiClient.get("/listings/search", { params });
      if (res && res.listings) {
        res.listings = res.listings.map(item => this.formatListing(item));
      }
      return res;
    } catch (e) {
      console.warn("Backend search failed, returning empty result:", e);
      return { listings: [], totalCount: 0, page: 0, totalPages: 0 };
    }
  }

  async getPropertyById(id) {
    if (!id) return null;
    try {
      const res = await ApiClient.get(`/listings/property/${id}`);
      return res ? this.formatListing(res) : null;
    } catch (e) {
      console.warn("Backend getPropertyById failed, checking local data:", e);
      const local = (this.fallbackData.listings || []).find(item => String(item.id) === String(id));
      return local ? this.formatListing(local) : null;
    }
  }

  async getExclusiveInfo(linkKey) {
    try {
      return await ApiClient.get(`/listings/exclusive/info/${linkKey}`);
    } catch (e) {
      console.error("Failed to load exclusive saved search info:", e);
      return null;
    }
  }

  async getExclusiveListings(linkKey, params) {
    try {
      const res = await ApiClient.get(`/listings/exclusive/search/${linkKey}`, { params });
      if (res && res.listings) {
        res.listings = res.listings.map(item => this.formatListing(item));
      }
      return res;
    } catch (e) {
      console.error("Failed to load exclusive listings:", e);
      return { listings: [], totalCount: 0, page: 0, totalPages: 0 };
    }
  }
}

export default new ListingService();

